<app-page-header [pageTitle]="'Inicio'" />

@if (loading) {
  <app-spinner />
} @else {
  <div class="space-y-6">
    @if (alertas && cantidadAlertas > 0) {
      <app-card [title]="'Alertas'">
        <ul class="divide-y divide-gray-100 dark:divide-gray-800">
          @for (alerta of alertas.ventanas_fiv; track alerta.id) {
            <li>
              <a [routerLink]="['/pive', alerta.id]"
                class="flex items-center gap-3 py-2.5 hover:bg-gray-50 dark:hover:bg-white/[0.03] rounded-lg px-2">
                <mat-icon [class]="alerta.estado === 'ideal' ? 'text-brand-500' : alerta.estado === 'tolerancia' ? 'text-warning-500' : 'text-error-500'">schedule</mat-icon>
                <span class="flex-1 text-sm text-gray-800 dark:text-white/90">
                  Ventana FIV
                  {{ alerta.estado === 'ideal' ? 'ideal' : alerta.estado === 'tolerancia' ? 'en tolerancia' : 'vencida' }}
                  · {{ alerta.cliente }} – {{ alerta.establecimiento }}
                  <span class="text-gray-500 dark:text-gray-400">({{ alerta.cantidad }} comb.)</span>
                </span>
                <span class="text-sm text-gray-500 dark:text-gray-400">máx. {{ diaMesHora(alerta.maximo_hasta) }}</span>
              </a>
            </li>
          }
          @for (alerta of alertas.cupo_opu; track alerta.fecha) {
            <li>
              <a [routerLink]="['/agendamientos']"
                class="flex items-center gap-3 py-2.5 hover:bg-gray-50 dark:hover:bg-white/[0.03] rounded-lg px-2">
                <mat-icon [class]="alerta.vacas > alerta.capacidad ? 'text-error-500' : 'text-warning-500'">event_busy</mat-icon>
                <span class="flex-1 text-sm text-gray-800 dark:text-white/90">
                  Cupo OPU {{ alerta.vacas > alerta.capacidad ? 'excedido' : 'completo' }} el {{ diaMes(alerta.fecha) }}
                </span>
                <span class="text-sm text-gray-500 dark:text-gray-400">{{ alerta.vacas }} / {{ alerta.capacidad }} vacas</span>
              </a>
            </li>
          }
          @for (alerta of alertas.contratos; track alerta.id) {
            <li>
              <a [routerLink]="['/crm/clientes', alerta.cli_cliente_id]"
                class="flex items-center gap-3 py-2.5 hover:bg-gray-50 dark:hover:bg-white/[0.03] rounded-lg px-2">
                <mat-icon [class]="alerta.vencido ? 'text-error-500' : 'text-warning-500'">description</mat-icon>
                <span class="flex-1 text-sm text-gray-800 dark:text-white/90">
                  Contrato {{ alerta.nro_contrato }} {{ alerta.vencido ? 'vencido' : 'por vencer' }} · {{ alerta.cliente }}
                </span>
                <span class="text-sm text-gray-500 dark:text-gray-400">{{ diaMes(alerta.fecha_fin) }}</span>
              </a>
            </li>
          }
        </ul>
      </app-card>
    }

    <div class="grid grid-cols-1 gap-6 xl:grid-cols-2">
      @if (agenda) {
        <app-card [title]="'Agenda'">
          <a card-actions routerLink="/agendamientos" class="text-sm font-medium text-brand-500 hover:text-brand-600">Calendario</a>
          @if (agenda.length === 0) {
            <p class="text-sm text-gray-500 dark:text-gray-400">Sin agendamientos esta semana.</p>
          }
          <div class="space-y-5">
            @for (dia of agenda; track dia.fecha) {
              <div>
                <h3 class="mb-2 text-sm font-semibold text-gray-700 dark:text-gray-300">{{ dia.etiqueta }}</h3>
                <ul class="space-y-2">
                  @for (item of dia.items; track item.tipo + item.id) {
                    <li>
                      <a [routerLink]="rutaAgenda(item)"
                        class="flex items-center gap-3 rounded-lg border border-l-4 border-gray-200 px-3 py-2 hover:bg-gray-50 dark:border-gray-800 dark:hover:bg-white/[0.03]"
                        [class.border-l-brand-500]="item.tipo === 'OPU'"
                        [class.border-l-success-500]="item.tipo === 'TE'">
                        <span class="w-9 text-xs font-semibold text-gray-500 dark:text-gray-400">{{ item.tipo }}</span>
                        <span class="w-11 text-sm text-gray-700 dark:text-gray-300">{{ item.hora ?? '—' }}</span>
                        <span class="min-w-0 flex-1">
                          <span class="block truncate text-sm font-medium text-gray-800 dark:text-white/90">{{ item.cliente }}</span>
                          <span class="block truncate text-xs text-gray-500 dark:text-gray-400">
                            {{ item.establecimiento }}
                            @if (item.cantidad) {
                              · {{ item.cantidad }} {{ item.tipo === 'OPU' ? 'vacas' : 'receptoras' }}
                            }
                            @if (item.fecha_fin && item.fecha_fin !== item.fecha) {
                              · hasta {{ diaMes(item.fecha_fin) }}
                            }
                          </span>
                        </span>
                        <app-badge size="sm" [color]="colorEstado(item.estado_codigo)">{{ item.estado_nombre }}</app-badge>
                      </a>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
        </app-card>
      }

      @if (pendientes) {
        <app-card [title]="'Pendientes del laboratorio'">
          @if (cantidadPendientes === 0) {
            <p class="text-sm text-gray-500 dark:text-gray-400">Sin pendientes.</p>
          }
          <div class="space-y-5">
            @if (pendientes.recepciones.length) {
              <div>
                <h3 class="mb-2 text-sm font-semibold text-gray-700 dark:text-gray-300">Recepción</h3>
                <ul class="space-y-1">
                  @for (p of pendientes.recepciones; track p.id) {
                    <li>
                      <a [routerLink]="['/pive', p.id]"
                        class="flex items-center gap-3 rounded-lg px-2 py-1.5 text-sm hover:bg-gray-50 dark:hover:bg-white/[0.03]">
                        <span class="w-12 text-gray-500 dark:text-gray-400">{{ diaMes(p.fecha) }}</span>
                        <span class="flex-1 truncate text-gray-800 dark:text-white/90">{{ p.cliente }} – {{ p.establecimiento }}</span>
                        <span class="text-gray-500 dark:text-gray-400">{{ p.cantidad }} comb.</span>
                      </a>
                    </li>
                  }
                </ul>
              </div>
            }
            @if (pendientes.fiv.length) {
              <div>
                <h3 class="mb-2 text-sm font-semibold text-gray-700 dark:text-gray-300">FIV</h3>
                <ul class="space-y-1">
                  @for (p of pendientes.fiv; track p.id) {
                    <li>
                      <a [routerLink]="['/pive', p.id]"
                        class="flex items-center gap-3 rounded-lg px-2 py-1.5 text-sm hover:bg-gray-50 dark:hover:bg-white/[0.03]">
                        <span class="w-12 text-gray-500 dark:text-gray-400">{{ diaMes(p.fecha) }}</span>
                        <span class="flex-1 truncate text-gray-800 dark:text-white/90">{{ p.cliente }} – {{ p.establecimiento }}</span>
                        <span class="text-gray-500 dark:text-gray-400">{{ p.cantidad }} comb.</span>
                      </a>
                    </li>
                  }
                </ul>
              </div>
            }
            @if (pendientes.cultivos.length) {
              <div>
                <h3 class="mb-2 text-sm font-semibold text-gray-700 dark:text-gray-300">Congelamiento</h3>
                <ul class="space-y-1">
                  @for (p of pendientes.cultivos; track p.id + p.fecha_fiv) {
                    <li>
                      <a [routerLink]="['/pive', p.id]"
                        class="flex items-center gap-3 rounded-lg px-2 py-1.5 text-sm hover:bg-gray-50 dark:hover:bg-white/[0.03]">
                        <span class="w-12 text-gray-500 dark:text-gray-400">Día {{ p.dia }}</span>
                        <span class="flex-1 truncate text-gray-800 dark:text-white/90">{{ p.cliente }} – {{ p.establecimiento }}</span>
                        <span class="text-gray-500 dark:text-gray-400">{{ p.cantidad }} cultivos</span>
                      </a>
                    </li>
                  }
                </ul>
              </div>
            }
            @if (pendientes.diagnosticos.length) {
              <div>
                <h3 class="mb-2 text-sm font-semibold text-gray-700 dark:text-gray-300">Diagnóstico de preñez</h3>
                <ul class="space-y-1">
                  @for (p of pendientes.diagnosticos; track p.id) {
                    <li>
                      <a [routerLink]="['/te', p.id]"
                        class="flex items-center gap-3 rounded-lg px-2 py-1.5 text-sm hover:bg-gray-50 dark:hover:bg-white/[0.03]">
                        <span class="w-12 text-gray-500 dark:text-gray-400">{{ p.dias }} d</span>
                        <span class="flex-1 truncate text-gray-800 dark:text-white/90">{{ p.cliente }} – {{ p.establecimiento }}</span>
                        <span class="text-gray-500 dark:text-gray-400">
                          @if (p.dx1) { DX1: {{ p.dx1 }} }
                          @if (p.dx1 && p.dx2) { · }
                          @if (p.dx2) { DX2: {{ p.dx2 }} }
                        </span>
                      </a>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
        </app-card>
      }
    </div>
  </div>
}
